import React, { useEffect } from 'react'
import { subscribeUserToPushNotification } from './NotificationService'
import config from '../../config'
import { urlBase64ToUint8Array } from '../../utils'

const NotificationPermission = ({ userId }) => {
  useEffect(() => {
    const requestPermission = async () => {
      try {
        const permission = await Notification.requestPermission()
        if (permission === 'granted') {
          // Check if service worker is registered
          const registration = await navigator.serviceWorker.ready

          const convertedVapidKey = urlBase64ToUint8Array(
            config.REACT_APP_VAPID_KEY
          )
          // Subscribe to push notifications
          const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: convertedVapidKey,
          })
          await subscribeUserToPushNotification(userId, subscription)
        } else {
          console.error('Notification permission not granted')
        }
      } catch (error) {
        console.error('Failed to request notification permission:', error)
      }
    }

    if ('serviceWorker' in navigator && 'PushManager' in window) {
      requestPermission()
    } else {
      console.error('Push messaging is not supported')
    }
  }, [])

  return <></>
}

export default NotificationPermission
